import React from "react";
import { Switch } from "antd";
import { CheckSquareOutlined, CloseOutlined } from "@ant-design/icons";

const columns = [
  {
    title: "Product Name",
    dataIndex: "bc_name",
    sorter: (a, b) => a.bc_name.localeCompare(b.bc_name),
    width: 200,
    ellipsis: true,
    onCell: () => ({
      className: 'bc-product-name-cell-button',
    }),
  },

  {
    title: "BC Product (SKU)",
    dataIndex: "bcSku",
    sorter: (a, b) => a.bcSku.localeCompare(b.bcSku),
    width: 200,
    ellipsis: true,
  },
  {
    title: "Active on Store",
    dataIndex: "active",
    render: (_, record) => <Switch checked={record.active} />,
    sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
    width: 150,
    ellipsis: true,
  },
  {
    title: "Store",
    dataIndex: "store",
    sorter: (a, b) => a.store.localeCompare(b.store),
    width: 100,
    ellipsis: true,
  },
  {
    title: "Enrichment",
    dataIndex: "enrichment",
    render: (text) =>
      text ? (
        <CheckSquareOutlined style={{ color: "green" }} />
      ) : (
        <CloseOutlined style={{ color: "red" }} />
      ),
    sorter: (a, b) => (a.enrichment === b.enrichment ? 0 : a.enrichment ? 1 : -1),
    width: 150,
    ellipsis: true,
  },
  {
    title: "Last Updated",
    dataIndex: "lastUpdated",
    sorter: (a, b) => {
      function parseDMY(dateStr) {
        if (!dateStr) return 0;
        const [datePart, timePart] = dateStr.split(', ');
        if (!datePart || !timePart) return 0;
        const [day, month, year] = datePart.split('/').map(Number);
        const [hour, minute, second] = timePart.split(':').map(Number);
        return new Date(year, month - 1, day, hour, minute, second).getTime();
      }
      return parseDMY(a.lastUpdated) - parseDMY(b.lastUpdated);
    },
    width: 200,
    ellipsis: true,
  },
  // {
  //   title: "Action",
  //   dataIndex: "action",
  //   render: (_, record) => <Button type="link">{record.action}</Button>,
  // },
];

export default columns;
